import React, { useState } from 'react';
import api from '../api';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function CreateEvent() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        start_date: '',
        start_time: '',
        end_date: '',
        end_time: '',
        location: '',
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await api.post('/events/', formData);
            toast.success('Event created successfully!');
            navigate('/events');
        } catch (err) {
            toast.error('Failed to create event.');
        }
    };

    return (
        <div className="container animate-fade-in" style={{ maxWidth: '600px', margin: '30px auto' }}>
            <h2 style={{ marginBottom: '20px' }}>Create New Event</h2>
            <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '15px' }}>
                <div>
                    <label style={{ display: 'block', marginBottom: '5px' }}>Event Name</label>
                    <input name="name" value={formData.name} onChange={handleChange} required style={{ width: '100%' }} />
                </div>
                <div>
                    <label style={{ display: 'block', marginBottom: '5px' }}>Description</label>
                    <textarea name="description" value={formData.description} onChange={handleChange} required style={{ width: '100%', minHeight: '100px' }} />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                    <div>
                        <label style={{ display: 'block', marginBottom: '5px' }}>Start Date</label>
                        <input name="start_date" type="date" value={formData.start_date} onChange={handleChange} required style={{ width: '100%' }} />
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: '5px' }}>Start Time</label>
                        <input name="start_time" type="time" value={formData.start_time} onChange={handleChange} required style={{ width: '100%' }} />
                    </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                    <div>
                        <label style={{ display: 'block', marginBottom: '5px' }}>End Date</label>
                        <input name="end_date" type="date" value={formData.end_date} onChange={handleChange} required style={{ width: '100%' }} />
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: '5px' }}>End Time</label>
                        <input name="end_time" type="time" value={formData.end_time} onChange={handleChange} required style={{ width: '100%' }} />
                    </div>
                </div>
                <div>
                    <label style={{ display: 'block', marginBottom: '5px' }}>Location</label>
                    <input name="location" value={formData.location} onChange={handleChange} required style={{ width: '100%' }} />
                </div>
                <button type="submit" style={{ padding: '12px', marginTop: '10px' }}>Create Event</button>
            </form>
        </div>
    );
}
